<template>
  <b-modal
    id="modalReview"
    data-testid="modal-review"
    hide-footer
    size="xl"
    :title="modal_review_title"
  >
    <ReviewsTable
      ref="reviews"
      :api_endpoint_="api_endpoint()"
      @close-modal="closeModal"
      @close-target="closeTarget($event)"
    />
  </b-modal>
</template>

<script>
import ReviewsTable from '@/contexts/reviews/ReviewsTable.vue'
import { rootBus } from '@/contexts/shared/event-bus/RootBus'

export default {
  name: 'ReviewsModal',
  components: { ReviewsTable },
  data: function () {
    return {
      source_obj: null,
      source: null,
    }
  },
  computed: {
    modal_review_title() {
      if (this.source === 'REMEDIATION') {
        return this._('Action reviews')
      } else {
        return this._('Reviews')
      }
    },
  },
  methods: {
    closeModal() {
      this.$bvModal.hide('modalReview')
    },
    api_endpoint() {
      if (this.source === 'REMEDIATION' && this.source_obj) {
        return 'remediation/' + this.source_obj.id + '/review'
      } else {
        return 'review'
      }
    },
    showReview(data) {
      this.$log.debug('DATA REVIEW', data)
      this.source_obj = data.source_obj
      this.source = data.source
      this.$bvModal.show('modalReview')
    },
    closeTarget(event) {
      if (this.$route.name === 'incidents' && event.incident_id) {
        rootBus.emit('closeIncident', event.incident_id)
      }
      if (this.$route.name === 'exemptions' && event.exemption_id) {
        rootBus.emit('closeExemption', event.exemption_id)
      }
      if (this.$route.name === 'gap' && event.gap_id) {
        rootBus.emit('closeGap', event.gap_id)
      }
      if (this.$route.name === 'project' && event.isp_project_id) {
        rootBus.emit('closeProject', event.isp_project_id)
      }
    },
  },
}
</script>
